export default __webpack_public_path__ + "static/media/dashboard-icon.dd6a3120.svg";